import createStyledEnhancer from "../helpers/createStyledEnhancer";

/*
 * Энхенсер для преобразования значений типа TFontSize (берет из токенов копмонента)
 * в шрифтовые стили (заданные глобально в теме), работает с брейкпоинтами;
 * используется внутри стайлед-компонента, напр:
 *
 * const Paragraph = styled.p<TParagraphProperties>`
 *  ${({theme, size = "s"}) => {
 *      const sizeConfig = theme.componentsTokens.paragraph.[size];
 *      return fontVariant({theme, fontVariant: sizeConfig.fontVariant});
 *  }}
 * `;
 *
 * также можно использвать набор энехенсеров:
 * const composed = composeEnhancers(fontVariant, paddings)
 * ...
 * // в стайлед-компоненте
 * const {fontVariant, pb} = theme.componentsTokens.paragraph.[size];
 * return composed({theme, fontVariant, pb});
 */
export var fontVariant = createStyledEnhancer({
  name: "fontVariant",
  directTransformation: true,
  transformation: function transformation(value, _ref) {
    var theme = _ref.theme;
    var _theme$font$sizes = theme.font.sizes[value],
        fontSize = _theme$font$sizes.fontSize,
        lineHeight = _theme$font$sizes.lineHeight;
    return {
      fontSize: fontSize,
      lineHeight: lineHeight
    };
  }
});